import * as actionTypes from '../consts/actionTypes';

export function postLogin(param) {
    return {
        type: actionTypes.POST_LOGIN,
        payload: param,
    };
}

export function postGoogleLogin(param) {
    return {
        type: actionTypes.POST_GOOGLE_LOGIN,
        payload: param,
    };
}

export function postLogout(param) {
    return {
        type: actionTypes.POST_LOGOUT,
        payload: param,
    };
}

export function postRegister(param) {
    return {
        type: actionTypes.POST_REGISTER,
        payload: param,
    };
}

export function getRetrieveUser(param) {
    return {
        type: actionTypes.GET_RETRIEVE_USER,
        payload: param,
    };
}

export function postConfirmUser(param) {
    return {
        type: actionTypes.POST_CONFIRM_USER,
        payload: param,
    };
}

export function clearLoginError() {
    return {
        type: actionTypes.CLEAR_ERROR_LOGIN,
    };
}

export function getValidateUsername(param) {
    return {
        type: actionTypes.GET_VALIDATE_USERNAME,
        payload: param,
    };
}

export function postPasswordRecover(param) {
    return {
        type: actionTypes.POST_PASSWORD_RECOVER,
        payload: param,
    };
}

export function putResetPassword(param) {
    return {
        type: actionTypes.PUT_RESET_PASSWORD,
        payload: param,
    };
}

export function postUpdateProfessional(param) {
    return {
        type: actionTypes.POST_UPDATE_PROFESSIONAL,
        payload: param,
    };
}

export function getAllUsers(param) {
    param.page = param?.page ?? 1;
    param.count = param?.count ?? 10
    param.searcher = param?.searcher ?? null
    param.is_profesional_confirmed = param?.is_profesional_confirmed ?? null
    param.profesional_data = param?.profesional_data ?? null
    return {
        type: actionTypes.GET_ALL_USERS,
        payload: param,
    };
}

export function getUserDetail(param) {
    return {
        type: actionTypes.GET_DETAIL_USER,
        payload: param,
    };
}